'use strict';

angular.module('app')
    .controller('AffiliateCtrl', function ($rootScope, $timeout, $location, info, affiliatesService, Auth, lang, utils) {
        var vm = this;

        vm.affiliate = { language: lang };
        vm.step = 1;
        vm.countryList = _.clone(info.countryList);
        vm.countryList.unshift({id: 'global', title: 'Global'});
        vm.affiliateKind = info.account.AFFILITATE_KIND;

        if (lang === 'de') {
            vm.affiliateKind = [
                [10, "PADI Tauchcenter"],
                [20, "PADI Professional"],
                [30, "Tauch- oder Reisewebsite"],
                [40, "Andere"]
            ]
        }
        vm.affiliateReg = affiliateReg;

        if ($location.search() && $location.search().success) {
            $timeout(function() {
                document.getElementById('main-btn').click();
                vm.step = 2;
                $location.search({ success: null })
            }, 300)
        }

        function affiliateReg (form) {
            if (Auth.isLoggedIn()) {
                form.loading = true;
                return affiliatesService.createNew(vm.affiliate).then(function(res) {
                        form.loading = false;
                        if (res.status === 400) {
                            return;
                        }

                        vm.step = 2;
                        jQuery.fancybox.update();
                    })
            } else {
                $rootScope.affiliateData = _.clone(vm.affiliate);
                jQuery.fancybox.close();
                $location.path(utils.createURL('/login/'));
            }
        }

    });
